function truncateToLines(element, lines = 3, suffix = '\u00A0...') {
    const originalText =
        element.dataset.originalText ??
        element.textContent.trim();

    element.dataset.originalText = originalText;
    element.textContent = originalText;

    const style = getComputedStyle(element);
    let lineHeight = parseFloat(style.lineHeight);

    if (Number.isNaN(lineHeight)) {
        lineHeight = parseFloat(style.fontSize) * 1.2;
    }

    const maxHeight = lineHeight * lines;

    if (element.scrollHeight <= maxHeight) {
        return;
    }

    const words = originalText.split(/\s+/);

    while (words.length) {
        words.pop();
        element.textContent = words.join(' ') + suffix;

        if (element.scrollHeight <= maxHeight) {
            break;
        }
    }
}

function truncateBlogTeaser() {
    document.querySelectorAll('.new-blog .metadata + h3').forEach(element => {
        truncateToLines(element, 2);
    });

    document.querySelectorAll('.new-blog .metadata + h3 + p').forEach(element => {
        truncateToLines(element, 3);
    });
}

truncateBlogTeaser();

window.addEventListener('resize', truncateBlogTeaser);
